import { useEffect, useState } from "react";

// Thin gradient progress bar fixed at the top of the viewport
// that fills up as the user scrolls the page. Uses the brand's
// orange→blue gradient — reminds visitors of the brand identity
// every time they move through content.
export default function ScrollProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const max = (document.documentElement.scrollHeight || 1) - window.innerHeight;
      const pct = max > 0 ? Math.min(100, Math.max(0, (scrollTop / max) * 100)) : 0;
      setProgress(pct);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] pointer-events-none"
      aria-hidden="true"
      data-testid="scroll-progress-bar"
    >
      <div
        className="h-full origin-left transition-transform duration-100 ease-out"
        style={{
          width: "100%",
          transform: `scaleX(${progress / 100})`,
          background: "linear-gradient(90deg, #f4851e 0%, #ffb870 40%, #4cb2ee 75%, #1e90d5 100%)",
          boxShadow: "0 0 12px rgba(244,133,30,0.6)",
        }}
      />
    </div>
  );
}
